import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UsersService } from 'src/app/services/users/users.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { entAnimations } from 'src/app/animations';
import { Subscription, lastValueFrom } from 'rxjs';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { Error } from 'src/app/models/error.model';
import { Router } from '@angular/router';
import { RouteStatusService } from 'src/app/services/maintenance/route-status.service';
import { CustomValidators } from 'src/app/utils/validators';

@Component({
  selector: 'app-password-recovery',
  templateUrl: './password-recovery.component.html',
  styleUrls: ['./password-recovery.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: entAnimations,
  standalone: false,
})
export class PasswordRecoveryComponent implements OnInit {
  forgotPasswordForm: FormGroup;

  // API Calls
  isBusy = false;
  isEmailSend = false;
  ErrorRecoveryEmail = false;
  error: Error = { error: { message: '', code: '' } };
  status: boolean;
  private subscription: Subscription = new Subscription();

  spinner = {
    color: 'primary',
    mode: 'indeterminate' as ProgressSpinnerMode,
    value: 50,
    diameter: 50,
  };

  /**
   * Constructor
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    private _formBuilder: FormBuilder,
    private _userService: UsersService,
    private _router: Router,
    private _routeStatusService: RouteStatusService
  ) {}

  ngOnInit(): void {
    // Get status for /password-recovery
    const urls = ['/password-recovery'];
    this.subscription.add(
      this._routeStatusService
        .getRouteStatusForUrls(urls)
        .subscribe(statuses => {
          // Retrieve the statuses or default to false if not found
          this.status = urls.some(url => statuses[url]);
        })
    );
    if (this.status) {
      if (this.status) {
        this._router.navigate(['/errors/error-maintenance']); // Redirect to maintenance page
      }
    }

    this.forgotPasswordForm = this._formBuilder.group({
      email: ['', [Validators.required, CustomValidators.validEmail()]],
    });
  }

  async sendResetLink(): Promise<void> {
    this.isEmailSend = false;
    this.ErrorRecoveryEmail = false;

    const recoveryEmail = this.forgotPasswordForm
      .get('email')
      .value.toString()
      .toLowerCase();

    try {
      this.isBusy = true;
      await lastValueFrom(this._userService.sendResetLink(recoveryEmail)).then(
        () => {
          this.isEmailSend = true;
          this.forgotPasswordForm.markAsPristine();
          this.forgotPasswordForm.markAsUntouched();
        }
      );
    } catch (error) {
      if (error.statusText == 'Unknown Error') {
        this.error = { error: { message: 'Unknown Error', code: 'ERR2' } };
      } else {
        if (error.error) {
          this.error = error.error;
        }
        if (this.error === undefined || this.error.error === undefined) {
          this.error = { error: { message: 'Unknown Error', code: 'ERR2' } };
        }
      }

      this.isEmailSend = false;
      this.ErrorRecoveryEmail = true;
    } finally {
      this.isBusy = false;
    }
  }
}
